import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../api.js";
import "../styles/login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/login/", {
        email,
        password,
      });

      const { refresh, access, user } = response.data;

      Cookies.set("access_token", access, { expires: 0.5 });
      Cookies.set("refresh_token", refresh, { expires: 30 });
      Cookies.set("user_id", user.id, { expires: 0.5 });
      Cookies.set("username", user.username, { expires: 0.5 });
      Cookies.set("user_role", user.role, { expires: 0.5 });

      navigate("/home");
    } catch (err) {
      setError("ایمیل یا رمز عبور نامعتبر است");
    }
  };

  return (
    <div className="login-page">
      <div className="login-form-wrapper">
        <div className="login-card">
          <h4 className="text-center mb-4">ورود  </h4>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label">ایمیل</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">رمز عبور</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-login btn-primary w-100">
              ورود
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
